<template>
    <v-container class="py-0 px-0" fluid v-if="this.$store.state.signedIn">
        <v-layout justify-center wrap>
            <v-flex xs12 class="py-0">
                <v-toolbar dark flat :color="use_color">
                    <v-toolbar-title :style="$store.state.textFormatting.headers" v-if="org_user=='user'"> {{username}} {{ asn_pref }} (OLD)
                        <v-tooltip top color="secondary">
                            <template v-slot:activator="{ on }">
                                <small v-on="on" :style="$store.state.textFormatting.main"> (select row to see explanation) </small>         
                            </template>
                            <span :style="$store.state.textFormatting.main">(select row to see explanation)</span>
                        </v-tooltip>
                    </v-toolbar-title>
                    <v-toolbar-title :style="$store.state.textFormatting.headers" v-if="org_user=='org'"> {{organisation}} {{ asn_pref }} (OLD)
                        <v-tooltip top color="secondary">
                            <template v-slot:activator="{ on }">
                                <small v-on="on" :style="$store.state.textFormatting.main"> (select row to see explanation) </small>         
                            </template>
                            <span :style="$store.state.textFormatting.main">(select row to see explanation)</span>
                        </v-tooltip>
                    </v-toolbar-title>
                    <v-progress-circular v-if="loading&&!show_prefixes" indeterminate color="white"></v-progress-circular>
                    <v-progress-circular v-if="loading2&&show_prefixes" indeterminate color="white"></v-progress-circular>
                    <v-spacer />
                    <v-spacer />
                    <v-spacer />
                    <v-flex shrink align-center justify-center>
                        <br />
                        <v-switch v-model="showAdvanced" @change="advancedChange()">
                            <template v-slot:label>
                                <div :style="$store.state.textFormatting.main"><b>Advanced settings</b></div>
                            </template>
                        </v-switch>
                    </v-flex>
                    <v-btn color="success" @click="flipCard" rounded> ASNs/ Prefixes </v-btn>
                    <v-flex shrink justify-center>
                        <v-tooltip top eager>
                        <span slot="activator" :style="$store.state.textFormatting.main">
                            <hr style="height:10px; visibility:hidden;" />
                            <v-switch v-model="show_lines" /> 
                        </span>
                        <span :style="$store.state.textFormatting.main">
                            Flip between explanations and table of ASN / Prefix settings
                        </span>
                        </v-tooltip>
                        
                    </v-flex>
                    <v-flex shrink>
                        <v-btn @click="showAll=!showAll" v-if="showAll" dark fab small color="blue"><h2> - </h2></v-btn>
                        <v-btn @click="showAll=!showAll" v-if="!showAll" dark fab small color="blue"><h2> + </h2></v-btn>
                    </v-flex>
                    <info>
                        <template slot>
                            ASN/ Restricted Prefix Rules Translation
                        </template>
                        <template slot="body">
                            <p> User sets their organisation / user thresholds for ASNs, and inserts 'Restricted Prefixes' to be monitored by their organsation (see 'Edit ASNs' and 'Edit Restricted Prefixes' pages). </p>
                            <p> This will display said rules, and a translation for what this actually means in terms of alerts coming in. </p>
                            <p> Press the button to switch between ASNs and prefixes. </p>
                            <p> Press the slider to display rules explanation for all ASNs/ prefixes, or click on a row in the table to display the explanation below the rules. </p>
                        </template>
                    </info>
                </v-toolbar>
                <v-card v-if="showAll&&!show_prefixes">
                    <v-data-table :headers="asnHeaders" :items="ASNs" :key="id"
                        :rows-per-page-items="rowsPerPageItems" :pagination.sync="pagination" v-if="!loading"
                        :expand="expand" item-key="asn"
                        > 
                        <template slot="headerCell" slot-scope="props">
                            <v-tooltip top eager>
                            <span slot="activator" :style="$store.state.textFormatting.main">
                                <div v-for="line in props.header.text" :key="line.index">
                                    <div> {{ line }} </div>
                                </div>
                            </span>
                            <span :style="$store.state.textFormatting.main">
                                {{ props.header.ad_text }}
                            </span>
                            </v-tooltip>
                        </template>
                        <template v-slot:items="props">
                            <tr @click="props.expanded=!props.expanded" v-if="!show_lines">
                                <td class="text-xs-center special" :style="$store.state.textFormatting.main"> <b> {{ props.item.asn }} </b> </td>
                                <td class="text-xs-left special" :style="$store.state.textFormatting.main" v-if="props.item.asn_name"> {{ props.item.asn_name }}</td>
                                <td class="text-xs-left special" :style="$store.state.textFormatting.main" v-if="!props.item.asn_name&&is_asn_owners">
                                    <div v-if="!asn_own_dict[props.item.asn]" :style="$store.state.textFormatting.main"> <v-progress-circular size="12" indeterminate color="purple" /></div>
                                    <div v-if="asn_own_dict[props.item.asn]"> {{ asn_own_dict[props.item.asn] }} </div>
                                </td>
                                <td :style="$store.state.textFormatting.main" class="text-xs-center special" v-if="showAdvanced"> {{ props.item.as_group }} </td>
                                <td class="text-xs-center special" :style="$store.state.textFormatting.main" v-if="showAdvanced"> 
                                    <v-icon v-if="props.item.opf_split[0]"> check </v-icon>
                                    <v-icon v-if="!props.item.opf_split[0]"> clear </v-icon>
                                    <span v-if="props.item.opf_split[0]">
                                        (
                                        <v-icon v-if="props.item.opf_split[4]"> check </v-icon>
                                        <v-icon v-if="!props.item.opf_split[4]"> clear </v-icon>
                                        <v-icon v-if="props.item.opf_split_e[0]"> check </v-icon>
                                        <v-icon v-if="!props.item.opf_split_e[0]"> clear </v-icon>
                                        )
                                    </span>
                                </td>
                                <td class="text-xs-center special" :style="$store.state.textFormatting.main" v-if="showAdvanced"> 
                                    <v-icon v-if="props.item.opf_split[1]"> check </v-icon>
                                    <v-icon v-if="!props.item.opf_split[1]"> clear </v-icon>
                                    <span v-if="props.item.opf_split[1]">
                                        (
                                        <v-icon v-if="props.item.opf_split_e[1]"> check </v-icon>
                                        <v-icon v-if="!props.item.opf_split_e[1]"> clear </v-icon>
                                        )
                                    </span>
                                </td>
                                <td class="text-xs-center special" :style="$store.state.textFormatting.main" v-if="showAdvanced"> 
                                    <v-icon v-if="props.item.opf_split[2]"> check </v-icon>
                                    <v-icon v-if="!props.item.opf_split[2]"> clear </v-icon>
                                    <span v-if="props.item.opf_split[2]">
                                        (
                                        <v-icon v-if="props.item.opf_split_e[2]"> check </v-icon>
                                        <v-icon v-if="!props.item.opf_split_e[2]"> clear </v-icon>
                                        )
                                    </span>
                                </td>
                                <td class="text-xs-center special" :style="$store.state.textFormatting.main" v-if="showAdvanced"> 
                                    <v-icon v-if="props.item.opf_split[3]"> check </v-icon>
                                    <v-icon v-if="!props.item.opf_split[3]"> clear </v-icon>
                                    <span v-if="props.item.opf_split[3]">
                                        (
                                        <v-icon v-if="props.item.opf_split_e[3]"> check </v-icon>
                                        <v-icon v-if="!props.item.opf_split_e[3]"> clear </v-icon>
                                        )
                                    </span>
                                </td>
                                <td class="text-xs-center special" :style="$store.state.textFormatting.main" v-if="showAdvanced"> {{ props.item.H }}</td>
                                <td class="text-xs-center special" :style="$store.state.textFormatting.main" v-if="showAdvanced"> {{ props.item.and_or }}</td>
                                <td class="text-xs-center special" :style="$store.state.textFormatting.main" v-if="showAdvanced"> {{ props.item.I }}</td>
                                <td class="text-xs-center special" :style="$store.state.textFormatting.main" v-if="showAdvanced"> {{ props.item.V }}</td>
                                <td class="text-xs-center special" :style="$store.state.textFormatting.main"> {{ props.item.notification_count }}</td>                                
                            </tr>
                            <tr v-if="show_lines">
                                <td class="text-xs-center" :style="$store.state.textFormatting.main"> <b> {{ props.item.asn }} </b> </td>
                                <td colspan="10" class="text-xs-left" :style="$store.state.textFormatting.main"> {{ props.item.explanation }} </td>
                            </tr>
                        </template>
                        <template v-if="!show_lines" v-slot:expand="props">
                            <v-card flat>
                                <v-card-text :style="$store.state.textFormatting.main">
                                    {{ props.item.explanation }}
                                </v-card-text>
                            </v-card>
                        </template>
                        <template slot="no-data">
                            <v-alert :value="true" color="success" icon="warning" :style="$store.state.textFormatting.main" v-if="org_user=='org'">
                                No organisation ASNs, add them in the 'Edit ASNs' page
                            </v-alert>
                            <v-alert :value="true" color="success" icon="warning" :style="$store.state.textFormatting.main" v-if="org_user=='user'">
                                No user ASNs, add them in the 'Edit ASNs' page
                            </v-alert>
                        </template>
                    </v-data-table>
                </v-card>

                <v-card v-if="showAll&&show_prefixes">
                    <v-data-table :headers="prefHeaders" :items="prefs" :key="id"
                        :rows-per-page-items="rowsPerPageItems2" :pagination.sync="pagination2" v-if="!loading2"
                        :expand="expand" item-key="prefix"
                        > 
                        <template slot="headerCell" slot-scope="props">
                            <v-tooltip top eager>
                            <span slot="activator" :style="$store.state.textFormatting.main">
                                <div v-for="line in props.header.text" :key="line.index">
                                    <div> {{ line }} </div>
                                </div>
                            </span>
                            <span :style="$store.state.textFormatting.main">
                                {{ props.header.ad_text }}
                            </span>
                            </v-tooltip>
                        </template>
                        <template v-slot:items="props">
                            <tr v-if="!show_lines">
                                <td @click="props.expanded=!props.expanded" class="text-xs-left special" :style="$store.state.textFormatting.main"> <b> {{ props.item.hostname }} </b> </td>
                                <td @click="props.expanded=!props.expanded" class="text-xs-center special" :style="$store.state.textFormatting.main"> {{ props.item.prefix }}</td>
                                <td @click="props.expanded=!props.expanded" class="text-xs-center special" :style="$store.state.textFormatting.main" v-if="showAdvanced"> {{ props.item.asn }} </td>
                                <td @click="props.expanded=!props.expanded" class="text-xs-center special" :style="$store.state.textFormatting.main" v-if="showAdvanced"> {{ props.item.impact_setting }}</td>
                                <td @click="props.expanded=!props.expanded" class="text-xs-center special" :style="$store.state.textFormatting.main" v-if="showAdvanced"> 
                                    <v-icon v-if="props.item.opf_split[0]"> check </v-icon>
                                    <v-icon v-if="!props.item.opf_split[0]"> clear </v-icon>
                                    <span v-if="props.item.opf_split[0]">
                                        (
                                        <v-icon v-if="props.item.opf_split[3]"> check </v-icon>
                                        <v-icon v-if="!props.item.opf_split[3]"> clear </v-icon>
                                        <v-icon v-if="props.item.opf_split_e[0]"> check </v-icon>
                                        <v-icon v-if="!props.item.opf_split_e[0]"> clear </v-icon>
                                        )
                                    </span>
                                </td>
                                <td @click="props.expanded=!props.expanded" class="text-xs-center special" :style="$store.state.textFormatting.main" v-if="showAdvanced"> 
                                    <v-icon v-if="props.item.opf_split[1]"> check </v-icon>
                                    <v-icon v-if="!props.item.opf_split[1]"> clear </v-icon>
                                    <span v-if="props.item.opf_split[1]">
                                        (
                                        <v-icon v-if="props.item.opf_split_e[1]"> check </v-icon>
                                        <v-icon v-if="!props.item.opf_split_e[1]"> clear </v-icon>
                                        )
                                    </span>
                                </td>
                                <td @click="props.expanded=!props.expanded" class="text-xs-center special" :style="$store.state.textFormatting.main" v-if="showAdvanced"> 
                                    <v-icon v-if="props.item.opf_split[2]"> check </v-icon>
                                    <v-icon v-if="!props.item.opf_split[2]"> clear </v-icon>
                                    <span v-if="props.item.opf_split[2]">
                                        (
                                        <v-icon v-if="props.item.opf_split_e[2]"> check </v-icon>
                                        <v-icon v-if="!props.item.opf_split_e[2]"> clear </v-icon>
                                        )
                                    </span>
                                </td>
                                
                                <td @click="props.expanded=!props.expanded" class="text-xs-center special" :style="$store.state.textFormatting.main"> {{ props.item.description }}</td>
                                <td class="text-xs-center" :style="$store.state.textFormatting.main">
                                    {{ props.item.notification_count }}
                                    <v-icon small color="success" v-if="!props.item.noti_show && props.item.notification_count > 0" @click="viewNotif(props.item)"> add </v-icon> 
                                    <v-icon color="success" v-if="props.item.noti_show && props.item.notification_count > 0" small @click="viewNotif(props.item)"> remove </v-icon> 
                                    <small v-if="props.item.noti_show">
                                        <br />
                                        {{ props.item.notification_str }}
                                    </small>
                                </td>
                            </tr>
                            <tr v-if="show_lines">
                                <td class="text-xs-center" :style="$store.state.textFormatting.main"> <b> {{ props.item.hostname }} </b> </td>
                                <td colspan="6" class="text-xs-left" :style="$store.state.textFormatting.main"> {{ props.item.explanation }} </td>
                            </tr>
                        </template>
                        <template v-if="!show_lines" v-slot:expand="props">
                            <v-card flat>
                                <v-card-text :style="$store.state.textFormatting.main">
                                    {{ props.item.explanation }}
                                </v-card-text>
                            </v-card>
                        </template>
                        <template slot="no-data">
                            <v-alert :value="true" color="success" icon="warning" :style="$store.state.textFormatting.main" v-if="org_user=='org'">
                                No organisation prefixes, add them in 'Edit Prefixes' page
                            </v-alert>
                            <v-alert :value="true" color="success" icon="warning" :style="$store.state.textFormatting.main" v-if="org_user=='user'">
                                No user prefixes, add them in 'Edit Prefixes' page
                            </v-alert>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import { API, graphqlOperation } from 'aws-amplify';
import store from '../../store';
import info from './infopopout.vue';
import downloadcsv from 'vue-json-csv';

export default {
    name: 'asnrules',
    components: {
        info,
        downloadcsv
    },
    props: 'type',
    describe: 'Shows ASN and prefix rules, can be set to be user or org specific',
    data() {
        return {
            valid: false,
            addType: "",
            loading: true,
            deleteASN: 0,
            edType: 'Add',
            showEdit: false,
            showAreYouSure: false,
            rowsPerPageItems: [10, 20, 50, 100],
            pagination: {
                rowsPerPage: 10
            },
            rowsPerPageItems2: [10, 20, 50, 100],
            pagination2: {
                rowsPerPage: 10
            },
            id: 1,
            organisation: '',
            asnHeaders: [
                { text: ['ASN'], ad_text:'Autonomous System Number', value: 'asn', align:'centre'},
                { text: ['Name'], ad_text:'AS Name from REGISTRY DATA, or USER defined name if available', value: 'asn_name', align:'centre'},
                { text: ['AS Group'], ad_text:'Define AS groups to omit / tweak alerts that occur between certain ASNs', value: 'as_group', align:'centre'},
                { text: ['Own. Assertions?'], ad_text:'Whether you will be alerted upon ownership assertions for this ASN (and receive emails on such alerts)', value: 'opf_split[0]', align:'centre'},
                { text: ['Path Changes?'], ad_text:'Whether you will be alerted on path change events for this ASN (and receive emails on such alerts)', value: 'opf_split[1]', align:'centre'},
                { text: ['First Seens?'], ad_text:'Whether you will be alerted upon first seen prefix events or not (and receive emails on such alerts)', value: 'opf_split[2]', align:'centre'},
                { text: ['AS In', 'Path Alerts?'], ad_text:'Whether you will be alerted upon alerts with this AS in the path - excluding this AS as the peer (and receive emails on such alerts)', value: 'opf_split[3]', align:'centre'},
                { text: ['Hijack', 'Threshold'], ad_text:'Hijack Score Threshold', value: 'H', align:'centre'},
                { text: ['And/ Or?'], ad_text:'To do with scoring mechanism - see info. in top right', value: 'and_or', align:'centre'},
                { text: ['Impact', 'Threshold'], ad_text:'Impact Score Threshold', value: 'I', align:'centre'},
                { text: ['Email', 'Summarisation','Threshold'], ad_text:'How many events needed for an additional email to be sent (where emails are enabled)', value: 'V', align:'centre'},
                { text: ['Alert', 'Count', '(last 7 days)'], ad_text:'Count of alerts over last week for given ASN', value: 'notification_count', align:'centre'},
            ],
            prefHeaders: [
                { text: ['Hostname'], ad_text:'A hostname you set for this prefix', value: 'hostname', align:'centre'},
                { text: ['IP Address'], ad_text:'IPv4/ IPv6 Address', value: 'prefix', align:'centre'},
                { text: ['ASN'], ad_text:'Associated ASN (for housekeeping purposes, NOT required)', value: 'asn', align:'centre'},
                { text: ['Impact'], ad_text:'Impact setting (alerts for this host will have Impact score set to this number)', value: 'impact_setting', align:'centre'},
                { text: ['Own. Assertions?'], ad_text:'Whether you will be alerted upon ownership assertions for this prefix (and receive emails on such alerts)', value: 'opf_split[0]', align:'centre'},
                { text: ['Path Changes?'], ad_text:'Whether you will be alerted on path change events for this prefix (and receive emails on such alerts)', value: 'opf_split[1]', align:'centre'},
                { text: ['First Seens?'], ad_text:'Whether you will be alerted upon first seen prefix events or not (and receive emails on such alerts)', value: 'opf_split[2]', align:'centre'},
                
                
                { text: ['Description'], ad_text:'Optional description (for housekeeping)', align:'centre'},
                { text: ['Email', 'Notifications', '(last 7 days)'], ad_text:'Count of notifications over the last 24h for this host', value: 'notification_count', align:'centre'},
            ],
            expanded: [],
            ASNs: [],
            displayMessage: false,
            username: '',
            loading2: false,
            parse_header: [],
            parse_csv: [],
            sortOrders: {},
            sortKey: '',
            showCSV: false,
            valid3: false,
            asn_own_dict: {},
            asn_get_owner: [],
            is_asn_owners: true,
            org_user: 'org',
            showASNs: true,
            showAll: true,
            singleExpand: false,
            expand: false,
            use_color: 'secondary',
            show_lines: false,
            prefs: [],
            asn_pref: 'ASN alert rules',
            show_prefixes: false,
            showAdvanced: true
        } 
    },
    beforeMount () {

        this.org_user = this.$attrs.type;
        if ( this.org_user == 'user') {
            this.use_color = 'accent'
        } else {
            this.use_color = 'secondary'
        }

        try {
            this.organisation = this.$store.state.user.organisation;
            this.username = this.$store.state.user.username;
        } catch (err) {
            console.log(err)
            location.reload()
        }
        
        this.getASNs();
        this.getPrefixes();
        this.showAdvanced = this.$store.state.showSettings.advancedSettings;
        this.showAll = this.$store.state.showSettings.showRules;
            
        this.advancedChange();
    },
    methods: {
        viewNotif: async function (item) {
            item.noti_show = !item.noti_show;
            this.loading2 = true;
            this.$nextTick(() => {
                // Add the component back in
                this.loading2 = false;
            });

        },
        flipCard: async function () {
            if (this.show_prefixes) {
                this.show_prefixes = false;
                this.asn_pref = 'ASN alert rules'
            } else {
                this.show_prefixes = true;
                this.asn_pref = 'Restricted prefix rules'
            }
        },
        getAnASNOwner: async function(asn) {
            if (asn == 0) {
                return "None";
            } else {
                try {
                    var qry = `query getASNOwner { getASNOwner ( asn: "` +
                    asn +
                    `" ) {
                            organisation
                        }
                    }`;
                    //console.log(qry);
                    const res = await API.graphql(graphqlOperation(qry));
                    var ownData = res.data.getASNOwner;
                    //console.log(ownData);
                    if (ownData) {
                        if (ownData.length > 0) {
                        //console.log("owner: ");
                        //console.log(ownData[0].organisation);
                            if (ownData[0].organisation) {
                                return ownData[0].organisation;
                            } else {
                                return "Unknown";
                            }
                        } else {
                            return "Unknown";
                        }
                    } else {
                        return "Unknown";
                    }
                } catch (err) {
                    console.log(err);
                    return "Unknown";
                }
            }
        },
        getASNOwners: async function () {
            
         //   console.log("gettign asn owners")
            for ( var i = 0 ; i < this.asn_get_owner.length ; i++ ) {
                var keys = Object.keys(this.asn_own_dict)
                if (!(keys.includes((this.asn_get_owner[i]).toString()))) {
                    this.asn_own_dict[this.asn_get_owner[i]] = await this.getAnASNOwner(this.asn_get_owner[i])
                }
                if ( i == this.asn_get_owner.length - 1 ) {
                    this.is_asn_owners = false
                    this.$nextTick(() => {
                        // Add the component back in
                        this.is_asn_owners = true;
                    });
                }
            }
        },
        convertASNToMeaning: function (asn) {
            var return_str;
            return_str = "Events that come in with AS " + (asn.asn).toString()
            if (asn.opf_split[0] || asn.opf_split[1] || asn.opf_split[2]) {
                return_str += " as the origin ASN (new or old)"
            }
            if (!asn.opf_split[0] || !asn.opf_split[1] || !asn.opf_split[2]) {   // we may have no exclusions
                return_str += ", excluding"
                var exceptions = []
                if (!asn.opf_split[0]) {
                    exceptions.push(" ownership assertions");
                }
                if (!asn.opf_split[1]) {
                    exceptions.push(" path changes");
                }
                if (!asn.opf_split[2]) {
                    exceptions.push(" first seens");
                }
                const exceptions_str = exceptions.join(" and") + ", will generate alerts"
                return_str += exceptions_str;
            }

            return_str += ". "

            if (asn.opf_split[3]) {
                return_str += "You will also be alerted if this AS appears in an AS path (old or new), excluding it being the peer ASN. "
            }

            
            


            if (asn.H > 0 || asn.I > 0) {  // if both are zero we have no score based exclusions
                return_str += 'They must also satisfy: HIJACK SCORE >= '
                return_str += (asn.H).toString()
                if (asn.and_or == 'and') {
                    return_str += ' AND '
                } else {
                    return_str += ' OR '
                }
                return_str += 'IMPACT SCORE >= '
                return_str += (asn.I).toString()
                return_str += '. '
            }
            
            if ((asn.opf_split[0] && asn.opf_split_e[0]) || (asn.opf_split[1] && asn.opf_split_e[1]) || (asn.opf_split[2] && asn.opf_split_e[2]) || (asn.opf_split[3] && asn.opf_split_e[3])) {
                var email_sends = [];
                if (asn.opf_split[0] && asn.opf_split_e[0]) {
                    email_sends.push(' ownership assertions')
                }
                if (asn.opf_split[1] && asn.opf_split_e[1]) {
                    email_sends.push(' path changes')
                }
                if (asn.opf_split[2] && asn.opf_split_e[2]) {
                    email_sends.push(' first seens')
                }
                if (asn.opf_split[3] && asn.opf_split_e[3]) {
                    email_sends.push(' AS in path alerts')
                }

                const email_str = 'You will be sent emails for' + email_sends.join(",") + '. '
                return_str += email_str;

                return_str += 'When the criteria are satisfied, an initial email will be sent out.'
                if (asn.V > 0) {
                    return_str += ' An additional email will be sent out after another '
                    return_str += (asn.V - 1).toString()
                    return_str += ' events satisfying such criteria occur in that 5 minute window. This will then continue to send emails for every '
                    return_str += (asn.V).toString()
                    return_str += ' events.'
                } else {
                    return_str += '.'
                }

            }

            return return_str
        },
        convertPrefixToMeaning: function (pref) {
            var return_str;
            var use_pref;
            if (pref.ipv4_address == '') {
                use_pref = pref.ipv6_address
            } else {
                use_pref = pref.ipv4_address
            }
            
            if (pref.opf_split[0] || pref.opf_split[1] || pref.opf_split[2]) {
                return_str = 
                "Where a parent/child/exact match on network range " +
                use_pref +
                " occurs in a BGP message, an alert will be created, with impact score of " +
                (pref.impact_setting).toString() + ". "
                if (!pref.opf_split[0] || !pref.opf_split[1] || !pref.opf_split[2]) {
                    var sends = []
                    if (pref.opf_split[0]) {
                        sends.push(' the ownership ASN changes (ownership assertion)')
                    }
                    if (pref.opf_split[1]) {
                        sends.push(' the ownership ASN stays the same (path change)')
                    }
                    if (pref.opf_split[2]) {
                        sends.push(' there was no previous owner (first seen event)')
                    }
                    var send_str = "It also has to satisfy one of the following criteria:" + sends.join(' OR') + ". "
                    return_str += send_str
                }

                if ((pref.opf_split[0] && pref.opf_split_e[0]) || (pref.opf_split[1] && pref.opf_split_e[1]) || (pref.opf_split[2] && pref.opf_split_e[2])) {
                    var email_sends = []
                    if (pref.opf_split[0]) {
                        email_sends.push(' ownership assertions')
                    }
                    if (pref.opf_split[1]) {
                        email_sends.push(' path changes')
                    }
                    if (pref.opf_split[2]) {
                        email_sends.push(' first seens')
                    }
                    var emails_str = "You will be alerted upon:" + email_sends.join(',') + ". "
                    return_str += emails_str
                }
            } else {
                return_str = 
                "Where a parent/child/exact match on network range " +
                use_pref +
                " occurs in a BGP message, an alert WOULD BE created (you need to change settings so at least one of the 3 options are selected), with impact score of " +
                (pref.impact_setting).toString() + "."
            }
            
            return return_str

        },
        getASNs: async function () {
            this.loading = true;
            var use_user
            if (this.org_user == 'user') {
                use_user = `p_user: "` + this.username + `",`
            } else {
                use_user = ''
            }
            
            var asQuery = `query getuserasn { getASNsForOrg (
                ` + use_user + `
                start_time: ` + Math.floor( Date.now() / 1000 - 604800 ) + `
                ) { 
                    asn 
                    H
                    I 
                    V 
                    notification_count 
                    peering_asn
                    type
                    alerting_type
                    exclude_peer
                    emails
                    and_or
                    asn_name
                    alert_name
                    as_group
                    own_path_first
                    emails_opf
                } 
            }`;

          //  console.log(asQuery);
            const asData = await API.graphql(graphqlOperation(asQuery));
          //  console.log(asData);
            var asns = asData.data.getASNsForOrg;

            if (asns.length == 0 || asns === undefined) {
                this.ASNs = [];
            } else {
                this.ASNs = [];
                var i;
                var toPush = [];
                for (i = 0; i < asns.length; i++) {
                    toPush = asns[i];
                    if (toPush.asn_name!='--' && toPush.alert_name=='--') {
                        try {
                            toPush.opf_split = toPush.own_path_first.split("")
                            for ( var j = 0 ; j < toPush.opf_split.length ; j++ ) {
                                toPush.opf_split[j] = toPush.opf_split[j] == 1 ? true : false;
                            }
                        } catch (e) {
                            console.log(e)
                            toPush.opf_split = [false, false, false, false]
                        }

                        try {
                            toPush.opf_split_e = toPush.emails_opf.split("")
                            for ( var j = 0 ; j < toPush.opf_split_e.length ; j++ ) {
                                toPush.opf_split_e[j] = toPush.opf_split_e[j] == 1 ? true : false;
                            }
                        } catch (e) {
                            console.log(e)
                            toPush.opf_split_e = [false, false, false, false]
                        }


                        if ( !(this.asn_get_owner.includes(toPush.asn)) ) {
                            this.asn_get_owner.push(toPush.asn)
                        }
                        if ( toPush.asn_name == '' || toPush.asn_name == '--') {
                            toPush.asn_name = false
                        }
                        toPush.explanation = this.convertASNToMeaning(toPush)
                        toPush.expanded = false
                        if ( i == toPush.length - 1 ) {
                            this.getASNOwners()
                        }
                        this.ASNs.push(toPush)

                    }
                }
            }
            this.loading = false;
        },
        getPrefixes: async function () {
            this.loading2 = true;
            var use_user
            if (this.org_user == 'user') {
                use_user = `p_user: "` + this.username + `",`
            } else {
                use_user = ''
            }
            
            var prefQuery = `query getControlledPrefixes { getControlledPrefixes (
                ` + use_user + `
                organisation: "` + this.organisation + `"
                ) { 
                    hostname
                    ipv4_address
                    ipv6_address
                    asn
                    description
                    send_emails
                    impact_setting
                    own_path_first
                    emails_opf
                } 
            }`;

         //   console.log(prefQuery);
            const prefData = await API.graphql(graphqlOperation(prefQuery));
         //   console.log(prefData);
            var prefs = prefData.data.getControlledPrefixes;
         //   console.log(prefs);

            if (prefs.length == 0 || prefs === undefined) {
                this.prefs = [];
            } else {
                this.prefs = prefs;
                var i;
                var toPush = [];
                for (i = 0; i < this.prefs.length; i++) {

                    try {
                        this.prefs[i].opf_split = this.prefs[i].own_path_first.split("")
                        for ( var j = 0 ; j < this.prefs[i].opf_split.length ; j++ ) {
                            this.prefs[i].opf_split[j] = this.prefs[i].opf_split[j] == 1 ? true : false;
                        }
                    } catch (e) {
                        console.log(e)
                        this.prefs[i].opf_split = [false, false, false]
                    }

                    try {
                        this.prefs[i].opf_split_e = this.prefs[i].emails_opf.split("")
                        for ( var j = 0 ; j < this.prefs[i].opf_split_e.length ; j++ ) {
                            this.prefs[i].opf_split_e[j] = this.prefs[i].opf_split_e[j] == 1 ? true : false;
                        }
                    } catch (e) {
                        console.log(e)
                        this.prefs[i].opf_split_e = [false, false, false]
                    }

                    if ( !(this.asn_get_owner.includes(this.prefs[i].asn)) ) {
                        this.asn_get_owner.push(this.prefs[i].asn)
                    }
                    if (this.prefs[i].ipv4_address == '') {
                        this.prefs[i].prefix = this.prefs[i].ipv6_address
                    } else {
                        this.prefs[i].prefix = this.prefs[i].ipv4_address
                    }
                    if (this.prefs[i].send_emails == 1) {
                        this.prefs[i].send_emails = true;
                        this.prefs[i].email_icon = "check";
                    } else {
                        this.prefs[i].send_emails = false;
                        this.prefs[i].email_icon = "clear";
                    }

                    this.prefs[i].explanation = this.convertPrefixToMeaning(this.prefs[i])
                    this.prefs[i].expanded = false
                    if ( i == this.prefs.length - 1 ) {
                        this.getASNOwners()
                    }
                }
            };
            this.loading2 = false;
            this.getControlledPrefixCounts();
        },
        getControlledPrefixCounts: async function () {
            try {

                if (this.org_user == 'user') {
                    var p_user = this.username;
                } else {
                    var p_user = 'whole_organisation'
                }

                var dd = Math.floor((new Date() / 1000) - 86400 * 7);
                var query = `query getNotificationsPerControlledPrefix {
                    getNotificationsPerControlledPrefix(
                        start_time: ` + dd + `,
                        organisation: "` + this.organisation + `",
                        p_user: "` + p_user + `",
                        ) {
                            prefix
                            controlled_prefix
                            event_count
                        }
                    }`
             //   console.log(query)
                const response = await API.graphql(graphqlOperation(query));
             //   console.log(response)
                var results = response.data.getNotificationsPerControlledPrefix
                if (results) {
                    if (results.length > 0) {
                        var cPreDicts = {};

                        for (var i = 0; i < results.length ; i++) {
                            var pre = results[i].prefix;
                            var cPre = results[i].controlled_prefix
                            var count = results[i].event_count
                            if (!(cPre in cPreDicts)) {
                                cPreDicts[cPre] = {"total": 0}
                            }
                            if (pre in cPreDicts[cPre]) {
                                cPreDicts[cPre][pre] += count
                            } else {
                                cPreDicts[cPre][pre] = count
                            }
                            cPreDicts[cPre]["total"] += count
                        }
                      //  console.log(cPreDicts)

                        for (var j = 0; j < this.prefs.length; j++) {
                            var entries = []
                            if (this.prefs[j].ipv4_address in cPreDicts) {
                                var preDict = cPreDicts[this.prefs[j].ipv4_address];
                      //          console.log(preDict)
                                this.prefs[j].notification_count = preDict["total"]
                                var keys = Object.keys(preDict);
                                //console.log(keys)
                                for (var k =0; k < keys.length ; k++) {
                                    if (keys[k] != "total") {
                                        entries.push(keys[k] + ": " + preDict[keys[k]])
                                    }
                                }
                                
                            } else {
                                this.prefs[j].notification_count = 0
                            }
                            if (this.prefs[j].ipv6_address in cPreDicts) {
                                var preDict = cPreDicts[this.prefs[j].ipv6_address];
                                this.prefs[j].notification_count += preDict["total"]
                                var keys = Object.keys(preDict);
                                //console.log(keys)
                                for (var k =0; k < keys.length ; k++) {
                                    if (keys[k] != "total") {
                                        entries.push(keys[k] + ": " + preDict[keys[k]])
                                    }
                                }
                            } else {
                                
                            }
                            this.prefs[j].notification_str = entries.join(", ")
                            this.prefs[j].noti_show = false;
                            this.loading2 = true;
                            this.$nextTick(() => {
                                // Add the component back in
                                this.loading2 = false;
                            });
                        }
                    } else {
                        for (var j = 0; j < this.prefs.length; j++) {
                            this.prefs[j].notification_count = 0
                            this.prefs[j].notification_str = ""
                        }
                    }
                } else {
                    for (var j = 0; j < this.prefs.length; j++) {
                        this.prefs[j].notification_count = 0
                        this.prefs[j].notification_str = ""
                    }
                }
            } catch (err) {
                console.log(err)
                for (var j = 0; j < this.prefs.length; j++) {
                    this.prefs[j].notification_count = 0
                    this.prefs[j].notification_str = ""
                }
            }
            this.loading2 = true;
            this.$nextTick(() => {
                // Add the component back in
                this.loading2 = false;
            });

        },
        advancedChange: async function () {
            if (!this.show_lines) {
                if (this.showAdvanced) {
                    this.asnHeaders = [
                        { text: ['ASN'], ad_text:'Autonomous System Number', value: 'asn', align:'centre'},
                        { text: ['Name'], ad_text:'AS Name from REGISTRY DATA, or USER defined name if available', value: 'asn_name', align:'centre'},
                        { text: ['AS Group'], ad_text:'Define AS groups to omit / tweak alerts that occur between certain ASNs', value: 'as_group', align:'centre'},
                        { text: ['Own. Assertions?'], ad_text:'Whether you will be alerted upon ownership assertions for this ASN (and receive emails on such alerts)', value: 'opf_split[0]', align:'centre'},
                        { text: ['Path Changes?'], ad_text:'Whether you will be alerted on path change events for this ASN (and receive emails on such alerts)', value: 'opf_split[1]', align:'centre'},
                        { text: ['First Seens?'], ad_text:'Whether you will be alerted upon first seen prefix events or not (and receive emails on such alerts)', value: 'opf_split[2]', align:'centre'},
                        { text: ['AS In', 'Path Alerts?'], ad_text:'Whether you will be alerted upon alerts with this AS in the path - excluding this AS as the peer (and receive emails on such alerts)', value: 'opf_split[3]', align:'centre'},
                        { text: ['Hijack', 'Threshold'], ad_text:'Hijack Score Threshold', value: 'H', align:'centre'},
                        { text: ['And/ Or?'], ad_text:'To do with scoring mechanism - see info. in top right', value: 'and_or', align:'centre'},
                        { text: ['Impact', 'Threshold'], ad_text:'Impact Score Threshold', value: 'I', align:'centre'},
                        { text: ['Email', 'Summarisation','Threshold'], ad_text:'How many events needed for an additional email to be sent (where emails are enabled)', value: 'V', align:'centre'},
                        { text: ['Email', 'Notifications', '(last 7 days)'], ad_text:'Count of notifications over last week for given ASN', value: 'notification_count', align:'centre'},
                    ];
                    this.prefHeaders = [
                        { text: ['Hostname'], ad_text:'A hostname you set for this prefix', value: 'hostname', align:'centre'},
                        { text: ['IP Address'], ad_text:'IPv4/ IPv6 Address', value: 'prefix', align:'centre'},
                        { text: ['ASN'], ad_text:'Associated ASN (for housekeeping purposes, NOT required)', value: 'asn', align:'centre'},
                        { text: ['Impact'], ad_text:'Impact setting (alerts for this host will have Impact score set to this number)', value: 'impact_setting', align:'centre'},
                        { text: ['Own. Assertions?'], ad_text:'Whether you will be alerted upon ownership assertions for this prefix (and receive emails on such alerts)', value: 'opf_split[0]', align:'centre'},
                        { text: ['Path Changes?'], ad_text:'Whether you will be alerted on path change events for this prefix (and receive emails on such alerts)', value: 'opf_split[1]', align:'centre'},
                        { text: ['First Seens?'], ad_text:'Whether you will be alerted upon first seen prefix events or not (and receive emails on such alerts)', value: 'opf_split[2]', align:'centre'},
                        
                        
                        { text: ['Description'], ad_text:'Optional description (for housekeeping)', align:'centre'},
                        { text: ['Email', 'Notifications', '(last 7 days)'], ad_text:'Count of notifications over the last 24h for this host', value: 'notification_count', align:'centre'},
                    ];
                } else {
                    this.asnHeaders = [
                        { text: ['ASN'], ad_text:'Autonomous System Number', value: 'asn', align:'centre'},
                        { text: ['Name'], ad_text:'User defined ASN name (for housekeeping)', value: 'asn_name', align:'centre'},
                        //{ text: 'AS Group', ad_text:'Define AS groups to omit / tweak alerts that occur between certain ASNs', value: 'as_group', align:'centre'},
                        //{ text: 'Own. Assertions?', ad_text:'Whether you will be alerted upon ownership assertions for this ASN (and receive emails on such alerts)', value: 'opf_split[0]', align:'centre'},
                        //{ text: 'Path Changes?', ad_text:'Whether you will be alerted on path change events for this ASN (and receive emails on such alerts)', value: 'opf_split[1]', align:'centre'},
                        //{ text: 'First Seens?', ad_text:'Whether you will be alerted upon first seen prefix events or not (and receive emails on such alerts)', value: 'opf_split[2]', align:'centre'},
                        //{ text: 'AS In Path Alerts?', ad_text:'Whether you will be alerted upon alerts with this AS in the path - excluding this AS as the peer (and receive emails on such alerts)', value: 'opf_split[3]', align:'centre'},
                        //{ text: 'H', ad_text:'Hijack Score Threshold', value: 'H', align:'centre'},
                        //{ text: 'I', ad_text:'Impact Score Threshold', value: 'I', align:'centre'},
                        //{ text: 'Alert Type', ad_text:'Either path or origin - see info. in top right', value: 'alerting_type', align:'centre'},
                        //{ text: 'Ex. Peer?', ad_text:'Yes / No - see info. in top right', value: 'exclude_peer', align:'centre'},
                        //{ text: 'Send Emails?', ad_text:'Whether the user/ organisation will receive emails based on alerts from this ASN', value: 'emails', align:'centre'},
                        //{ text: 'And/ Or?', ad_text:'To do with scoring mechanism - see info. in top right', value: 'and_or', align:'centre'},
                        //{ text: 'V', ad_text:'Validation Score Threshold', value: 'V', align:'centre'},
                        { text: ['Email', 'Notifications', '(last 7 days)'], ad_text:'Count of notifications over last week for given ASN', value: 'notification_count', align:'centre'},
                        //{ text: 'Actions', ad_text:'Edit or delete the ASN', align:'centre', sortable: false}
                    ];
                    this.prefHeaders = [
                        { text: ['Hostname'], ad_text:'A hostname you set for this prefix', value: 'hostname', align:'centre'},
                        { text: ['IP Address'], ad_text:'IPv4/ IPv6 Address', value: 'prefix', align:'centre'},
                        //{ text: ['ASN'], ad_text:'Associated ASN (for housekeeping purposes, NOT required)', value: 'asn', align:'centre'},
                        //{ text: ['Impact'], ad_text:'Impact setting (alerts for this host will have Impact score set to this number)', value: 'impact_setting', align:'centre'},
                        //{ text: ['Own. Assertions?'], ad_text:'Whether you will be alerted upon ownership assertions for this prefix (and receive emails on such alerts)', value: 'opf_split[0]', align:'centre'},
                        //{ text: ['Path Changes?'], ad_text:'Whether you will be alerted on path change events for this prefix (and receive emails on such alerts)', value: 'opf_split[1]', align:'centre'},
                        //{ text: ['First Seens?'], ad_text:'Whether you will be alerted upon first seen prefix events or not (and receive emails on such alerts)', value: 'opf_split[2]', align:'centre'},
                        
                        
                        { text: ['Description'], ad_text:'Optional description (for housekeeping)', align:'centre'},
                        { text: ['Email', 'Notifications', '(last 7 days)'], ad_text:'Count of notifications over the last 24h for this host', value: 'notification_count', align:'centre'},
                    ];
                }
            }
        },
    },
    watch: {
        showAll (n) {
            this.$store.commit("setShowSettings", { 'showRules': n });
            //console.log(this.$store.state.showSettings)
        },
        showAdvanced (n) {
         //   console.log("setting show advanced settings")
         //   console.log(n)
            this.$store.commit("setShowSettings", { 'advancedSettings': n });
         //   console.log(this.$store.state.showSettings)
        },
        show_lines(n) {
            if (n) {
                //console.log("SHOW LINES")
                this.asnHeaders = [
                    { text: ['ASN'], ad_text:'Autonomous System Number', value: 'asn', align:'centre'},
                    { text: ['Explanation'], ad_text:'ASN Rules converted into a human readable passage. If this doesn\'t provide a clear enough explanation on how alerts are created please feedback to us.', value: 'asn_name', align:'centre'},
                ];
                this.prefHeaders = [
                    { text: ['Hostname'], ad_text:'A hostname you set for this prefix', value: 'hostname', align:'centre'},
                    { text: ['Explanation'], ad_text:'Prefix Rules converted into a human readable passage. If this doesn\'t provide a clear enough explanation on how alerts are created please feedback to us.', value: 'asn_name', align:'centre'},
                ];
            } else {
                //console.log("NOT SHOWING LINES")
                if (this.showAdvanced) {
                    this.asnHeaders = [
                        { text: ['ASN'], ad_text:'Autonomous System Number', value: 'asn', align:'centre'},
                        { text: ['Name'], ad_text:'AS Name from REGISTRY DATA, or USER defined name if available', value: 'asn_name', align:'centre'},
                        { text: ['AS Group'], ad_text:'Define AS groups to omit / tweak alerts that occur between certain ASNs', value: 'as_group', align:'centre'},
                        { text: ['Own. Assertions?'], ad_text:'Whether you will be alerted upon ownership assertions for this ASN (and receive emails on such alerts)', value: 'opf_split[0]', align:'centre'},
                        { text: ['Path Changes?'], ad_text:'Whether you will be alerted on path change events for this ASN (and receive emails on such alerts)', value: 'opf_split[1]', align:'centre'},
                        { text: ['First Seens?'], ad_text:'Whether you will be alerted upon first seen prefix events or not (and receive emails on such alerts)', value: 'opf_split[2]', align:'centre'},
                        { text: ['AS In', 'Path Alerts?'], ad_text:'Whether you will be alerted upon alerts with this AS in the path - excluding this AS as the peer (and receive emails on such alerts)', value: 'opf_split[3]', align:'centre'},
                        { text: ['Hijack', 'Threshold'], ad_text:'Hijack Score Threshold', value: 'H', align:'centre'},
                        { text: ['And/ Or?'], ad_text:'To do with scoring mechanism - see info. in top right', value: 'and_or', align:'centre'},
                        { text: ['Impact', 'Threshold'], ad_text:'Impact Score Threshold', value: 'I', align:'centre'},
                        { text: ['Email', 'Summarisation','Threshold'], ad_text:'How many events needed for an additional email to be sent (where emails are enabled)', value: 'V', align:'centre'},
                        { text: ['Email', 'Notifications', '(last 7 days)'], ad_text:'Count of notifications over last week for given ASN', value: 'notification_count', align:'centre'},
                    ];
                    this.prefHeaders = [
                        { text: ['Hostname'], ad_text:'A hostname you set for this prefix', value: 'hostname', align:'centre'},
                        { text: ['IP Address'], ad_text:'IPv4/ IPv6 Address', value: 'prefix', align:'centre'},
                        { text: ['ASN'], ad_text:'Associated ASN (for housekeeping purposes, NOT required)', value: 'asn', align:'centre'},
                        { text: ['Impact'], ad_text:'Impact setting (alerts for this host will have Impact score set to this number)', value: 'impact_setting', align:'centre'},
                        { text: ['Own. Assertions?'], ad_text:'Whether you will be alerted upon ownership assertions for this prefix (and receive emails on such alerts)', value: 'opf_split[0]', align:'centre'},
                        { text: ['Path Changes?'], ad_text:'Whether you will be alerted on path change events for this prefix (and receive emails on such alerts)', value: 'opf_split[1]', align:'centre'},
                        { text: ['First Seens?'], ad_text:'Whether you will be alerted upon first seen prefix events or not (and receive emails on such alerts)', value: 'opf_split[2]', align:'centre'},
                        
                        
                        { text: ['Description'], ad_text:'Optional description (for housekeeping)', align:'centre'},
                        { text: ['Email', 'Notifications', '(last 7 days)'], ad_text:'Count of notifications over the last 24h for this host', value: 'notification_count', align:'centre'},
                    ];
                } else {
                    this.asnHeaders = [
                        { text: ['ASN'], ad_text:'Autonomous System Number', value: 'asn', align:'centre'},
                        { text: ['Name'], ad_text:'User defined ASN name (for housekeeping)', value: 'asn_name', align:'centre'},
                        //{ text: 'AS Group', ad_text:'Define AS groups to omit / tweak alerts that occur between certain ASNs', value: 'as_group', align:'centre'},
                        //{ text: 'Own. Assertions?', ad_text:'Whether you will be alerted upon ownership assertions for this ASN (and receive emails on such alerts)', value: 'opf_split[0]', align:'centre'},
                        //{ text: 'Path Changes?', ad_text:'Whether you will be alerted on path change events for this ASN (and receive emails on such alerts)', value: 'opf_split[1]', align:'centre'},
                        //{ text: 'First Seens?', ad_text:'Whether you will be alerted upon first seen prefix events or not (and receive emails on such alerts)', value: 'opf_split[2]', align:'centre'},
                        //{ text: 'AS In Path Alerts?', ad_text:'Whether you will be alerted upon alerts with this AS in the path - excluding this AS as the peer (and receive emails on such alerts)', value: 'opf_split[3]', align:'centre'},
                        //{ text: 'H', ad_text:'Hijack Score Threshold', value: 'H', align:'centre'},
                        //{ text: 'I', ad_text:'Impact Score Threshold', value: 'I', align:'centre'},
                        //{ text: 'Alert Type', ad_text:'Either path or origin - see info. in top right', value: 'alerting_type', align:'centre'},
                        //{ text: 'Ex. Peer?', ad_text:'Yes / No - see info. in top right', value: 'exclude_peer', align:'centre'},
                        //{ text: 'Send Emails?', ad_text:'Whether the user/ organisation will receive emails based on alerts from this ASN', value: 'emails', align:'centre'},
                        //{ text: 'And/ Or?', ad_text:'To do with scoring mechanism - see info. in top right', value: 'and_or', align:'centre'},
                        //{ text: 'V', ad_text:'Validation Score Threshold', value: 'V', align:'centre'},
                        { text: ['Email', 'Notifications', '(last 7 days)'], ad_text:'Count of notifications over last week for given ASN', value: 'notification_count', align:'centre'},
                        //{ text: 'Actions', ad_text:'Edit or delete the ASN', align:'centre', sortable: false}
                    ];
                    this.prefHeaders = [
                        { text: ['Hostname'], ad_text:'A hostname you set for this prefix', value: 'hostname', align:'centre'},
                        { text: ['IP Address'], ad_text:'IPv4/ IPv6 Address', value: 'prefix', align:'centre'},
                        //{ text: ['ASN'], ad_text:'Associated ASN (for housekeeping purposes, NOT required)', value: 'asn', align:'centre'},
                        //{ text: ['Impact'], ad_text:'Impact setting (alerts for this host will have Impact score set to this number)', value: 'impact_setting', align:'centre'},
                        //{ text: ['Own. Assertions?'], ad_text:'Whether you will be alerted upon ownership assertions for this prefix (and receive emails on such alerts)', value: 'opf_split[0]', align:'centre'},
                        //{ text: ['Path Changes?'], ad_text:'Whether you will be alerted on path change events for this prefix (and receive emails on such alerts)', value: 'opf_split[1]', align:'centre'},
                        //{ text: ['First Seens?'], ad_text:'Whether you will be alerted upon first seen prefix events or not (and receive emails on such alerts)', value: 'opf_split[2]', align:'centre'},
                        
                        
                        { text: ['Description'], ad_text:'Optional description (for housekeeping)', align:'centre'},
                        { text: ['Email', 'Notifications', '(last 7 days)'], ad_text:'Count of notifications over the last 24h for this host', value: 'notification_count', align:'centre'},
                    ];
                }
            }
        }
    }
}
</script>

<style scoped>
    
    table.v-table tbody td:first-child, 
    table.v-table tbody td:not(:first-child), 
    table.v-table tbody th:first-child, 
    table.v-table tbody th:not(:first-child), 
    table.v-table thead td:first-child, 
    table.v-table thead td:not(:first-child), 
    table.v-table thead th:first-child, 
    table.v-table thead th:not(:first-child) {
        padding: 0 5px
    }

    table.v-table tbody td , 
    table.v-table thead th {
        height: 38px;
    }

    .special
    {
        cursor: pointer;
    }


</style>

